<template>
  <div class="md:layout-grid md:mb-24 md:py-24">
    <div
      class="md:layout-grid-contain mt-16 flex flex-wrap items-end gap-24 md:gap-12 xxxl:mx-[-264px]"
    >
      <InputText
        v-model.lazy="text"
        class="ml-16 mr-auto max-w-lg flex-1 md:ml-0"
        type="text"
        icon-end="search"
        :title="searchPlaceholder"
      />

      <ProductFinderBarModes v-if="isWatchMode" :mode="mode" />

      <button
        class="button is-primary mr-12 md:mr-0"
        @click="sidebarOpen = true"
      >
        <span class="hidden md:inline">{{
          $texts('productFinder.openFilterButton', 'Filter')
        }}</span>
        <SpriteSymbol name="filter" />
      </button>
    </div>
  </div>
  <Teleport to="body">
    <Transition name="drawer" :duration="300">
      <ProductFinderDrawer
        v-if="sidebarOpen"
        :selected-facets="selectedFacets"
        :text="text"
        :mode="mode"
        @close="sidebarOpen = false"
      />
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { ProductFinderMode } from '#graphql-operations'

const props = defineProps<{
  selectedFacets: Record<string, string[]>
  mode: ProductFinderMode
}>()

const { $texts } = useEasyTexts()

const searchPlaceholder = computed(() => {
  if (isWatchMode.value) {
    return $texts(
      'watchFinder.inputPlaceholder',
      'Search product with SKU No° or name',
    )
  }

  return $texts('productFinder.inputPlaceholder', 'Search product with SKU No°')
})

const isWatchMode = computed(() => {
  return (
    props.mode === ProductFinderMode.Watches_actual ||
    props.mode === ProductFinderMode.Watches_limited ||
    props.mode === ProductFinderMode.Watches_archived
  )
})

const sidebarOpen = ref(false)

const text = defineModel<string>()
</script>

<style lang="postcss">
.drawer-enter-active,
.drawer-leave-active {
  @apply transition duration-300;
  .drawer-background,
  .drawer-content {
    transition: inherit;
  }

  .drawer-content {
    @apply ease-swing;
  }
}
.drawer-enter-from,
.drawer-leave-to {
  .drawer-background {
    @apply opacity-0;
  }
  .drawer-content {
    @apply translate-x-full;
  }
}
</style>
